// extracted by mini-css-extract-plugin
module.exports = {"container":"LifeStyleCard_container__3JCpO","title":"LifeStyleCard_title__2UWbg","about":"LifeStyleCard_about__1-1wD"};